import { render, staticRenderFns } from "./PayrollMovementCreate.vue?vue&type=template&id=1d9d0a44&scoped=true"
import script from "./PayrollMovementCreate.vue?vue&type=script&lang=js"
export * from "./PayrollMovementCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9d0a44",
  null
  
)

export default component.exports